'use strict';

/*@ngInject*/
module.exports = function () {
    return {
        scope: {
            referenceId: '<',
            imageId: '<',
            imageName: '<',
            modalOpened: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        /*@ngInject*/
        controller: function controller() {
            var vm = this;

            vm.close = function () {
                vm.modalOpened = false;
            };
        },
        template: require('./image-modal.html')
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/image-modal.directive.js
 **/